import React from "react";
import { useNavigate } from "react-router-dom";
import { Helpers } from "../../../../helpers/Helpers";

interface Props {
    meetingId: string | undefined
}

const ActionButtons = ({
    meetingId
}: Props) => {
    const navigate = useNavigate();
    return (
        <React.Fragment>
            {
                !Helpers.isEmpty(meetingId) && (
                    <React.Fragment>
                        <div className='m-0'>
                            <a
                                onClick={() => navigate('/antrepooffer/listadd?meetingId=' + meetingId)}
                                className='btn btn-sm fw-bold btn-success'
                            >
                                <i className="fa fa-plus"></i>&nbsp;Teklif Oluştur
                            </a>
                        </div>
                    </React.Fragment>
                )
            }

        </React.Fragment >
    )
}

export default ActionButtons;